import type { Role } from '@99designs/site-navigation/consts';

export interface NavigationRole {
    isAdmin: boolean;
    isDesigner: boolean;
}

export function getNavigationRole(navigationRole: NavigationRole | null): Role {
    if (!navigationRole) {
        return 'logged-out';
    } else if (navigationRole.isAdmin) {
        return 'contest-holder';
    } else if (navigationRole.isDesigner) {
        return 'designer';
    } else {
        return 'contest-holder';
    }
}
